export enum AuthMechanismEnum {
  jwt = 'jwt',
  webeam = 'webeam',
}

export function isAuthMechanism(value: any): value is AuthMechanismEnum {
  return Object.values(AuthMechanismEnum).includes(value);
}

export interface PublicConfigEnvironment {
  BACKEND_URL: string;
  SOCKET_IO_HOST: string;
  SOCKET_IO_PORT: string;
  AUTH_MECHANISM: string;
  WEBEAM_E2E_URL: string;
  WEBEAM_E2E_CLIENT_ID: string;
  WEBEAM_E2E_CLIENT_SECRET: string;
  WEBEAM_E2E_REDIRECT_URI: string;
  WEBEAM_E2E_REALM_PATH: string;
}

export interface PublicConfig {
  env: PublicConfigEnvironment;
}

export type CoordinateNamePageParams = {
  [key in 'coordinate' | 'name']: string;
};

export type ZoneNamePageParams = {
  [key in 'coordinate' | 'zoneName' | 'name']: string;
};
